<div class="banks-participants-modal">
  <div class="banks-participants-modal__header">
    <h2 class="banks-participants-modal__header-title" id="banks-participants-modal-title">
      Bancos Participantes
    </h2>
    <button
      type="button"
      class="banks-participants-modal__close"
      aria-label="Cerrar"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="banks-participants-modal__body">
    <h3 class="banks-participants-modal__title">Bancos Participantes</h3>
    <p class="banks-participants-modal__subtitle">Hasta 12 meses sin intereses</p>

    <div class="banks-participants-modal__grid">
      <div class="banks-participants-modal__bank" *ngFor="let bank of banks">
        <img
          *ngIf="showLogo(bank)"
          class="banks-participants-modal__bank-logo"
          [src]="bank.logo"
          [alt]="bank.name"
          loading="lazy"
          (error)="onLogoError(bank)"
        />
        <span *ngIf="!showLogo(bank)" class="banks-participants-modal__bank-name">{{ bank.name }}</span>
      </div>
    </div>

    <p class="banks-participants-modal__disclaimer">{{ disclaimer }}</p>
  </div>
</div>
